module.exports = __webpack_public_path__ + "img/1.0c7d79f8.jpg";